import React from "react";
import PropTypes from "prop-types";
import MyCareerPage from "./careers/my_career_page";
import CareerSection from "./careers/career_section";

function CareerCompnent(props) {
  const { is_mypage } = props;

  return is_mypage === true ?
    <MyCareerPage {...props} /> : <CareerSection {...props} />;
}

CareerCompnent.propTypes = {
  is_mypage: PropTypes.bool.isRequired
};

export default CareerCompnent;
